export const AUTHENTICATION_REQUIRED_CODE = 'authentication_required';

/**
 * Read JSON without turning an HTML or malformed error response into a second
 * parsing failure. Callers remain responsible for handling a null result.
 */
export async function readJsonResponse(response) {
    if (!response || typeof response.json !== 'function') return null;

    try {
        return await response.json();
    } catch {
        return null;
    }
}

export function isAuthenticationRequiredResponse(response, data) {
    return (
        response?.status === 401 && data?.code === AUTHENTICATION_REQUIRED_CODE
    );
}

export function handleAuthenticationRequiredResponse(
    response,
    data,
    { userStore, modalsStore } = {}
) {
    if (!isAuthenticationRequiredResponse(response, data)) return false;

    userStore?.markSessionExpired?.();
    modalsStore?.replace?.('sign-in-modal');

    return true;
}

/**
 * Gate recovery for authenticated reads so ordinary login events do nothing
 * and one expired-session response permits at most one post-login refetch.
 */
export function createAuthenticatedReadRecovery({
    refreshUser,
    isLoggedIn,
    refetch
}) {
    let pending = false;

    return {
        request() {
            pending = true;
        },

        async handleLogin() {
            if (!pending) return false;

            // Consume before awaiting so duplicate login events cannot replay
            // the same read more than once.
            pending = false;
            await refreshUser();

            if (!isLoggedIn()) return false;

            await refetch();
            return true;
        }
    };
}
